<template>
  <v-container>
    <energizerPhotoTagging></energizerPhotoTagging>
  </v-container>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import energizerPhotoTagging from "@/components/energizerPhotoTagging";

export default {
  name: 'PhotoTagging',
  components: {
    energizerPhotoTagging
  },
  data() {
    return {
      selectedCategory: 0,
      dialog: {
        modal: false
      }
    }
  },
  mounted() {
  },
  computed: {
    ...mapState({
      photos: state => state.photos.photos,
      tags: state => state.tags.tags,
      categories: state => state.categories.categories,
    }),

  },
  methods: {
    ...mapActions(['bulkUpdate', 'getPhotosByFilter', 'submitAssigned']),
    ...mapMutations(['setMessage', 'setPhotos']),

  }
}
</script>


<style scoped>
.border--primary {
  border: 1px solid #666;
  border-radius: 4px;
  padding: 10px;
}

.fixed {
  position: fixed !important;
  bottom: 0 !important;
  font-size: 40px;
  /* margin:auto; */
  z-index: 999;
  background: white;

}

.v-chip .v-chip__content {
  height: auto !important;
}

.v-text-field {
  padding-top: 0;
  margin-top: 0;
}
</style>
